(function() {
    'use strict';

    angular
        .module('historyApp')
        .controller('ClaimCasePoliciesController', ClaimCasePoliciesController);

    ClaimCasePoliciesController.$inject = ['$scope', '$uibModalInstance','items','$uibModal','NgTableParams','GLOBAL_URL','$log','CLAIM_TYPE','FORMAT_DATE'];

    function ClaimCasePoliciesController ($scope, $uibModalInstance,  items,$uibModal, NgTableParams, GLOBAL_URL,$log,CLAIM_TYPE,FORMAT_DATE) {
    	var claimCasePoliciesCtr = this;
    	var self = $scope;
		
		self.CLAIM_TYPE = CLAIM_TYPE;
		self.FORMAT_DATE = FORMAT_DATE;
    	var data = items;
    	
    	claimCasePoliciesCtr.items = items;
    	claimCasePoliciesCtr.tableParams = new NgTableParams({
    	      page: 1, // show first page
    	      count: 100000000,
    	      sorting: { registerDate: "desc" } 
    	    }, {
    	      dataset: data,
    	      counts :[]
    	    });
    	
    	claimCasePoliciesCtr.ok= ok;
    	claimCasePoliciesCtr.cancel= cancel;

    	  function ok() {
    		  $uibModalInstance.close(claimCasePoliciesCtr.selected.item);
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    	  
    	  
    }
})();
